import Form from 'components/Form';
import { Fragment, useState, useEffect } from 'react';
import { IPatientInfo } from 'apis/admin/type';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';
import {
  Button,
  IconButton,
  Stack,
  FormHelperText,
  Table,
  Typography,
  TableBody,
  TableCell,
} from '@mui/material';
import { Delete } from '@mui/icons-material';

import { Ti18nId } from 'hooks/useI18n';
import { IInpomation } from 'apis/survey/type';
import useInfoEtc from 'store/patientEtc/useinfoEtc';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import RowContentInfo from './components/RowContentInfo';
import MuiTable from './MuiTable';
import MuiTextField from 'components/Form/MuiTextField';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const PatientInfo = (props: Props) => {
  const {
    disabled,
    nurseName,
    patientInfo,
    register,
    watch,
    onRequired,
    onSuccess,
    setValue,
  } = props;

  return (
    <RowContainer xs={12}>
      <RowContent title="Tên bệnh nhân" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={patientInfo.name}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Mã số đăng ký" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={patientInfo.patient_id}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Tuổi" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={patientInfo.age}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Giới tính" titleRatio={1} childrenRatio={2}>
        <Form.MuiRadioGroup
          i18nKey="GENDER"
          values={[1, 2]}
          value={patientInfo.gender}
          defaultValue={patientInfo.gender}
        />
      </RowContent>
      <RowContent title="Khoa điều trị" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={patientInfo.department}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Bác sĩ phụ trách" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={patientInfo.main_doctor}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Người ghi chép" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={nurseName} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContentInfo
        title="Người cung 
cấp thông tin"
        titleRatio={1}
        childrenRatio={2}
      >
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập trực tiếp"
          {...register('offer')}
        />
      </RowContentInfo>
      <Table sx={{ marginLeft: '16px' }}>
        <TableBody>
          <TableCell></TableCell>
        </TableBody>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 'bold',
            marginLeft: '16px',
            marginTop: '16px',
          }}
        >
          Người giám hộ
        </Typography>
      </Table>
      <RowContent title="Người giám hộ 1" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register('contact1.0.contact')}
        />
      </RowContent>
      <RowContent title="Quan hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact1.0.name`)}
        />
      </RowContent>
      <RowContent title="Liên hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact1.0.relation`)}
        />
      </RowContent>
      <RowContent title="Khác" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Ví dụ: Hướng dẫn điều trị"
          {...register(`contact1.0.etc`)}
        />
      </RowContent>

      <RowContent title="Người giám hộ 2" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact2.0.contact`)}
        />
      </RowContent>
      <RowContent title="Quan hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact2.0.name`)}
        />
      </RowContent>
      <RowContent title="Liên hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact2.0.relation`)}
        />
      </RowContent>
      <RowContent title="Khác" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Ví dụ: Hướng dẫn điều trị"
          {...register(`contact2.0.etc`)}
        />
      </RowContent>

      <RowContent title="Người giám hộ 3" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact3.0.contact`)}
        />
      </RowContent>
      <RowContent title="Quan hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact3.0.name`)}
        />
      </RowContent>
      <RowContent title="Liên hệ" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Nhập thông tin"
          {...register(`contact3.0.relation`)}
        />
      </RowContent>
      <RowContent title="Khác" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          required={false}
          fullWidth={false}
          disabled={disabled}
          placeholder="Ví dụ: Hướng dẫn điều trị"
          {...register(`contact3.0.etc`)}
        />
      </RowContent>
    </RowContainer>
  );
};

export default PatientInfo;
